import React from "react";
import { GoCheck } from "react-icons/go";
import { BsBoxArrowInUpRight, BsBoxArrowDownLeft } from "react-icons/bs";

const HelperChecklist = ({
  checklistBg,
  checklistTxt,
  checklistWine,
  openHelper,
  setOpenHelper,
}) => {
  return (
    <section className={`helper-checklist ${openHelper ? "open" : "closed"}`}>
      {!openHelper ? (
        <div className="open-helper-btn" onClick={() => setOpenHelper(true)}>
          <BsBoxArrowDownLeft />
        </div>
      ) : (
        <div>
          <div
            className="close-helper-btn"
            onClick={() => setOpenHelper(false)}
          >
            <BsBoxArrowInUpRight />
          </div>
          <h3> Need help? Follow this checklist:</h3>
          <p className={`${checklistBg ? "checked" : ""}`}>
            {checklistBg ? <GoCheck /> : "1. "} Select a template or a
            background or upload your own image
          </p>
          <p className={`${checklistTxt ? "checked" : ""}`}>
            {checklistTxt ? <GoCheck /> : "2. "} Add some text to customize your
            label
          </p>
          <p className={`${checklistWine ? "checked" : ""}`}>
            {checklistWine ? <GoCheck /> : "3. "} Once you're happy with your
            label, pick a wine to add to your cart
          </p>
        </div>
      )}
    </section>
  );
};

export default HelperChecklist;
